import type BABYLON from 'babylonjs';

import type { Globals } from './globals';
import { loggerError } from './logger';

export interface FilesInputOptions {
  sceneLoadedCallback?: ConstructorParameters<typeof BABYLON.FilesInput>[2];
  progressCallback?: ConstructorParameters<typeof BABYLON.FilesInput>[3];
  additionalRenderLoopLogicCallback?: ConstructorParameters<typeof BABYLON.FilesInput>[4];
  textureLoadingCallback?: ConstructorParameters<typeof BABYLON.FilesInput>[5];
  startingProcessingFilesCallback?: ConstructorParameters<typeof BABYLON.FilesInput>[6];
  onReloadCallback?: ConstructorParameters<typeof BABYLON.FilesInput>[7];
  onProcessFileCallback?: typeof BABYLON.FilesInput.prototype.onProcessFileCallback;
  loadAsync?: typeof BABYLON.FilesInput.prototype.loadAsync;
}

export function createFilesInput(
  globals: Globals,
  engine: BABYLON.Engine,
  {
    sceneLoadedCallback = null,
    progressCallback = null,
    additionalRenderLoopLogicCallback = null,
    textureLoadingCallback = null,
    startingProcessingFilesCallback = null,
    onReloadCallback = null,
    onProcessFileCallback,
    loadAsync,
  }: FilesInputOptions = {}
): BABYLON.FilesInput | null {
  const canvas = engine.getRenderingCanvas();
  if (!canvas) return null;

  const filesInput = new globals.BABYLON.FilesInput(
    engine,
    null,
    sceneLoadedCallback,
    progressCallback,
    additionalRenderLoopLogicCallback,
    textureLoadingCallback,
    startingProcessingFilesCallback,
    onReloadCallback,
    (_file, _scene, message) => {
      loggerError(globals, message);
    }
  );
  if (onProcessFileCallback) filesInput.onProcessFileCallback = onProcessFileCallback;
  if (loadAsync) filesInput.loadAsync = loadAsync;
  filesInput.monitorElementForDragNDrop(canvas);
  return filesInput;
}
